module.exports = __webpack_public_path__ + "static/media/icon-electronics-full-disabled.2188d5d3.png";